import React, { useEffect } from "react";
import { Paper, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getFormattedNumber, prettyNumericRound } from "../../../utils";
import CustomLabel from "../../../components/CustomLabel";
import { useLazyGetSSTotalQuery } from "../../../services/ssTotalApi";

const PaperSx = { px: 1, py: 0.5, display: "flex", alignItems: "center" };

const CenterAlignSx = { display: "flex", alignItems: "center" };

const StoreSuppliesTotals = () => {
  const store = useSelector((store) => store.global.store);
  const total = useSelector((store) => store.ssTotal);
  const [getSSTotal] = useLazyGetSSTotalQuery();

  useEffect(() => {
    getSSTotal({ storeId: store?.id, type: "initialLoad" });
  }, [getSSTotal, store?.id]);

  return (
    <Paper sx={PaperSx}>
      <Grid container spacing={0} columns={15} sx={CenterAlignSx}>
        <Grid item xs={0.8}>
          <Typography variant="caption" fontWeight={500} color="primary">
            TOTAL
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <CustomLabel
            label="Selected"
            value={`${total?.selected}/${total?.totalPogs}`}
          />
        </Grid>
        <Grid item xs={2}>
          <CustomLabel label="SKU Qty" value={total?.skuQty} />
        </Grid>
        <Grid item xs={2.5}>
          <CustomLabel
            label="Total Adj Cost"
            value={`$${getFormattedNumber(
              prettyNumericRound(total?.totalAdjCost || 0)
            )}`}
          />
        </Grid>
        <Grid item xs={2.5}>
          <CustomLabel
            label="Free Adj Cost"
            value={`$${getFormattedNumber(
              prettyNumericRound(total?.freeAdjCost || 0)
            )}`}
          />
        </Grid>
        <Grid item xs={2.5}>
          <CustomLabel
            label="Non-Free Adj Cost"
            value={`$${getFormattedNumber(
              prettyNumericRound(total?.nonFreeAdjCost || 0)
            )}`}
          />
        </Grid>
        <Grid item xs={2.5}>
          <CustomLabel
            label="Free Acq Cost"
            value={`$${getFormattedNumber(
              prettyNumericRound(total?.acqCost || 0)
            )}`}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default StoreSuppliesTotals;
